export default {"src":"/polygon/_next/static/media/near.a682065f.svg","height":10,"width":10};